<template>
  <m-basic-form
      @save="save"
      @remove="remove"
      :loadingMsg="loadingMsg"
      :loadingShow="loadingShow"
      :formId="ID"
  >
    <div class="row">
      <div class="col-5">
        <m-input v-model="form.VEHICLENAME" langlabel="vehicleplate" />
        <m-input v-model="form.VEHICLEBARCODE" langlabel="vehiclebarcode" />
        <m-input v-model="form.SEAL_VALUE" langlabel="sealvalue" /> <!--langlabel labelda isim deperi-->

        <!-- Çoklu Hat Seçimi -->
        <div class="mt-10 pl-3">
          <label class="font-weight-bold">Hat Seçimi</label>

          <div class="d-flex flex-wrap">
            <b-form-checkbox
                v-for="line in lines"
                :key="line.ROUTEID"
                v-model="form.LINES"
                :value="line.ROUTEID"
                class="mr-4 mb-2"
            >
              {{ line.name }}
            </b-form-checkbox>
          </div>
        </div>

        <b-form-checkbox
            v-model="form.ISRINGVEHICLE"
        >
          {{ $t("info.isringvehicle") }}
        </b-form-checkbox>
      </div>
    </div>
    <a :href="printerUrl" v-show="false" ref="printerBtn">Yazdır</a>
    <template slot="footer">
      <b-button @click="printAction" size="sm" squared variant="warning"
      >Barkod Yazdır</b-button
      >
    </template>
  </m-basic-form>
</template>

<script>
import api from "../../api";
import swal from "sweetalert";
export default {
  mounted() {
    if (intval(this.$route.params.id) > 0) {
      this.ID = intval(this.$route.params.id);
      this.getVehicle(this.ID);
    }
    this.getRoute();
  },
  computed: {
    printerUrl() {
      return `prdr://vehiclebarcode_temp%20ID=${this.ID}%200`;
    },
  },
  data() {
    return {
      ID: null,
      form: {
        VEHICLENAME: null,
        VEHICLEBARCODE: null,
        ISRINGVEHICLE: false,
        SEAL_VALUE: null,
        LINES: []     // ✔ çoklu hat seçimi burada tutulacak
      },
      // Hat listesi (statik ya da API’den gelebilir)
      lines: [
      ],
      loadingShow: false,
      loadingMsg: null,
    };
  },
  methods: {
    printAction() {
      // this.$refs.printerBtn.click();
      window.top.location.href = `prdr://vehiclebarcode_temp%20ID=${this.ID}%200`; // +
    },
    getRoute() {
      api.getRoute()
          .then((res) => {
            if (res.data.status && !res.data.msg) {
              this.lines = res.data.data.rows.map(item => {
                return {
                  ROUTEID: item.ID,
                  name: item.ROUTENAME
                };
              });
            }
          })
          .catch((err) => {"..."});
    },
    saveVehicle(){
      this.loadingMsg = this.$t("dialog.savingrecord");
      this.loadingShow = true;

      // ✔ LINES formatını API'nin istediği hale dönüştür
      const payload = {
        ...this.form,
        LINES: this.form.LINES.map(id => ({
          ROUTEID: id,
          CHECKED: "1"
        }))
      };

      api
          .saveVehicle(payload, this.ID)
          .then((res) => {
            if (res.data.status) {
              if (this.ID == res.data.data.ID) {
                swal({
                  icon: "success",
                  title: this.$t("dialog.success"),
                  text:
                      "Başarıyla kayıt güncellendi, barkod yazdırmak istiyor musunuz?",
                  buttons: ["Vazgeç", "Evet"],
                }).then((isOk) => {
                  if (isOk) {
                    this.printAction();
                  }
                });
              } else {
                this.ID = res.data.data.ID;
                swal({
                  icon: "success",
                  title: this.$t("dialog.success"),
                  text:
                      "Başarıyla kayıt edildi, barkod yazdırmak istiyor musunuz?",
                  buttons: ["Vazgeç", "Evet"],
                }).then((isOk) => {
                  if (isOk) {
                    this.printAction();
                  }
                });
              }
            } else {
              swal(
                  this.$t("dialog.notice"),
                  this.$t("dialog.anerrorhasccurred") + res.data.errMsg,
                  "error"
              );
            }
          })
          .catch((err) => {
            swal(
                this.$t("dialog.systemerror"),
                this.$t("dialog.anerrorhasccurred") + err.toString(),
                "error"
            );
          })
          .finally(() => {
            this.loadingShow = false;
          });
    },
    save() {
      if (!this.form.SEAL_VALUE) {
        swal({
          icon: "info",
          title: this.$t("dialog.info"),
          text: "Mühür no alanı boş, devam etmek istiyor musunuz?",
          buttons: ["Vazgeç", "Evet"], // İlk buton "Vazgeç" (Hayır), ikinci buton "Evet"
        }).then((isOk) => {
          if (isOk) {
            this.saveVehicle()
          }else{
            return;
          }
        });
      }else{
        this.saveVehicle()
      }
    },
    getVehicle(id) {
      this.loadingMsg = this.$t("dialog.fetchingdata");
      this.loadingShow = true;

      api.getVehicleOne(id)
          .then((res) => {
            if (res.data.status && !res.data.msg) {
              const { VEHICLENAME, VEHICLEBARCODE, ISRINGVEHICLE, SEAL_VALUE, LINES } =
                  res.data.data;

              // API'den direkt OBJE olarak geliyor, JSON.parse kullanılmayacak
              const selected = LINES
                  .filter(line => line.CHECKED == "1")
                  .map(line => Number(line.ROUTEID));

              this.form = {
                ...this.form,
                VEHICLENAME,
                VEHICLEBARCODE,
                ISRINGVEHICLE,
                SEAL_VALUE,
                LINES: selected // ✔ checkbox'lar için doğru format
              };
            }
          })
          .finally(() => {
            this.loadingShow = false;
          });
    },
    remove() {
      this.loadingMsg = this.$t("dialog.removingrecord");
      this.loadingShow = true;
      api
          .deleteVehicle(this.ID)
          .then((res) => {
            if (res.data.status && res.data.msg) {
              swal(this.$t("dialog.info"), res.data.msg, "info");
            } else {
              swal(
                  this.$t("dialog.notice"),
                  this.$t("dialog.anerrorhasccurred") + res.data.errMsg,
                  "error"
              );
            }
          })
          .catch((err) => {
            swal(
                this.$t("dialog.systemerror"),
                this.$t("dialog.anerrorhasccurred") + err.toString(),
                "error"
            );
          })
          .finally(() => {
            this.loadingShow = false;
          });
    },
  },
};
</script>

<style></style>
